<template>
  <div>
    <b-modal
      id="insufficientBalanceModal"
      modal-class="insufficient-balance-modal-cover"
      v-model="isVisible"
      hide-footer
      centered
    >
      <div class="insufficient-balance-modal-content" :dir="isHebrew ? 'rtl' : 'ltr'">
        <div class="icon-wrap">
          <i class="fas fa-wallet"></i>
        </div>

        <h3 class="modal-title">
          {{ dynamicModal && dynamicModal.textKey ? t(dynamicModal.textKey) : t('insufficientBalanceTitle') }}
        </h3>

        <p class="modal-subtitle">
          {{ dynamicModal && dynamicModal.subTextKey ? t(dynamicModal.subTextKey) : defaultSubText }}
        </p>

        <div class="cta-group">
          <b-button class="cta-btn whatsapp-btn" @click="openWhatsAppContact">
            {{ dynamicModal && dynamicModal.actionTextKey ? t(dynamicModal.actionTextKey) : t('insufficientWhatsapp') }}
          </b-button>

          <b-button class="cta-btn call-btn" @click="callUs">
            {{ t('insufficientCallUs') }}
          </b-button>
        </div>

        <b-button variant="link" class="close-link" @click="closePopup">
          {{ t('close') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: "InsufficientBalanceModal",
  props: ["value"],
  mixins: [translationMixin],
  computed: {
    ...mapGetters(["dynamicModal"]),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    defaultSubText() {
      return this.t('insufficientBalanceMessage');
    },
  },
  methods: {
    ...mapActions(["showModal"]),
    closePopup() {
      this.showModal("");
    },
    openWhatsAppContact() {
      const message = this.t('dynamicModalCreditFinishedMessage');
      const url = `https://wa.me/972526867915?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
      this.showModal("");
    },
    callUs() {
      window.location.href = "tel:0526867915";
      this.showModal("");
    },
  },
};
</script>

<style scoped>
.insufficient-balance-modal-content {
  text-align: center;
  padding: 0.5rem 0.5rem 0.25rem;
}

.icon-wrap {
  width: 72px;
  height: 72px;
  margin: 0 auto 0.8rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #34d0b6, #07a0c3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 30px;
}

.modal-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #0d2f29;
  margin-bottom: 0.8rem;
}

.modal-subtitle {
  font-size: 1.55rem;
  line-height: 1.65;
  color: #39424e;
  margin: 0 auto 1.2rem;
  max-width: 95%;
  white-space: pre-line;
}

.cta-group {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  margin-bottom: 0.5rem;
}

.cta-btn {
  border: 0;
  border-radius: 12px;
  padding: 0.85rem 1rem;
  font-size: 1.45rem;
  font-weight: 700;
}

.whatsapp-btn {
  background: linear-gradient(45deg, #25d366, #128c7e);
  color: #fff;
}

.whatsapp-btn:hover {
  color: #fff;
  filter: brightness(1.03);
}

.call-btn {
  background: #f3f7fa;
  color: #0d2f29;
}

.call-btn:hover {
  background: #e8f0f5;
  color: #0d2f29;
}

.close-link {
  font-size: 1.3rem;
  color: #6b7280;
}
</style>

